import Vue from 'vue'

export function SET_UPTIME (state, payload) {
    state.uptime = payload
}

export function UNSET_UPTIME (state) {
    state.uptime = undefined
}

export function SET_VALUE (state, payload = {}) {
    state[payload.key] = payload.value
}

export function SET_TEORIA_STATS (state, { id_contenuto, completamento, progresso }) {
    const id = Number(id_contenuto)
    const ts = Date.now()
    const idx = state.teoriaStats.findIndex(s => Number(s.id_contenuto) === id)
    if (idx >= 0) {
        Vue.set(state.teoriaStats, idx, { ...state.teoriaStats[idx], id_contenuto: id, completamento, progresso, ts })
    } else {
        state.teoriaStats.push({ id_contenuto: id, completamento, progresso, ts })
    }
}

export function SET_TEORIA_PREFERITO (state, { id_contenuto, preferito }) {
    const id = Number(id_contenuto)
    const idx = state.teoriaStats.findIndex(s => Number(s.id_contenuto) === id)
    if (idx >= 0) {
        Vue.set(state.teoriaStats, idx, { ...state.teoriaStats[idx], id_contenuto: id, preferito })
    } else {
        state.teoriaStats.push({ id_contenuto: id, completamento: false, progresso: 0, preferito })
    }
}

export function SET_TEORIA_LETTURE (state, { id_contenuto, letture }) {
    const id = Number(id_contenuto)
    const idx = state.teoriaStats.findIndex(s => Number(s.id_contenuto) === id)
    if (idx >= 0) {
        Vue.set(state.teoriaStats, idx, { ...state.teoriaStats[idx], id_contenuto: id, letture })
    } else {
        state.teoriaStats.push({ id_contenuto: id, completamento: false, progresso: 0, letture })
    }
}

export function REMOVE_TEORIA_STATS (state, { id_contenuto }) {
    const id = Number(id_contenuto)
    state.teoriaStats = state.teoriaStats.filter(s => Number(s.id_contenuto) !== id)
}
